import React, { useState } from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import Dialog from "../../common/dialog";
import ElementSmileyIcon from "../../common/icons/elements/ElementSmileyIcon";
import EmojiPicker from "../../common/emoji-picker/EmojiPicker";
import ImageComponent from "../../common/ImageComponent";
import ManaButton from "../../common/ManaButton";
import ManaTextInput from "../../common/ManaTextInput";
import fontStyles from "../../../fonts";

export default function QuickElementCreationDialog({
  createElement = () => {},
  close = () => {},
}) {
  const [icon, setIcon] = useState("");
  const [name, setName] = useState("");

  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        marginTop: 0,
        paddingTop: 14,
        paddingBottom: 12,
        minHeight: 360,
      }}
    >
      <View style={styles.header}>
        <Text style={[fontStyles.h4, styles.title]}>
          Enter Element Name & Choose Emoji
        </Text>
      </View>

      {/* Name & icon */}
      <View style={styles.inputContainer}>
        <View style={[styles.imageContainer]}>
          {icon ? (
            <ImageComponent style={styles.icon} icon={icon} />
          ) : (
            <ElementSmileyIcon style={styles.icon} />
          )}
        </View>

        <ManaTextInput
          style={styles.input}
          placeholderTextColor="#ABADB3"
          contentHeight={40}
          debounceDelay={300}
          name={"editElement"}
          placeholder={""}
          onTextChanged={(text) => setName(text)}
          value={name || ""}
        />
      </View>

      {/* EmojiPicker */}
      <EmojiPicker
        style={{
          maxWidth: "100%",
          borderColor: "#ABADB3",
        }}
        selectEmoji={(emoji) => setIcon(emoji.unified || emoji.id)}
        autoFocus={false}
      />

      {/* Buttons */}
      <View style={[styles.buttons, { marginTop: 8 }]}>
        <ManaButton
          style={[styles.button, { marginRight: 6 }]}
          styleText={styles.buttonText}
          text="Back"
          onPress={close}
        />

        <ManaButton
          isMainButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text="Create Element"
          disabled={!name || !icon}
          onPress={() => createElement({ edit_name: name, edit_icon: icon })}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {
    justifyContent: "center",
  },
  title: {},
  inputContainer: {
    width: "100%",
    position: "relative",
    height: 40,
    marginVertical: 8,
    //marginHorizontal: 6,
  },
  input: {
    paddingLeft: 50,
    margin: 0,
    maxHeight: 40,
    marginBottom: 0,
    shadowOpacity: 0,
    borderWidth: 0.5,
    borderColor: "#ABADB3",
  },
  favoriteIcon: {
    position: "absolute",
    right: 0,
    top: 0,
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imageContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 100,
    elevation: 3,
  },
  icon: {
    width: 30,
    height: 30,
  },
  buttons: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50%",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  image: {
    marginVertical: 16,
  },
});
